import { useBespokeSectionContext } from './BespokeSectionContext';
import { useControlDisabled } from './ControlDisabledContext';

export interface OASISRadioOptionProps {
  qid: string;
  value: string;
  className?: string;
}

/**
 * A single selectable option for a radio QID.  Multiple OASISRadioOption nodes
 * sharing the same qid form one radio group — useful for placing radio inputs
 * inside table cells or other arbitrary layouts.
 */
export function OASISRadioOption({
  qid,
  value,
  className,
}: OASISRadioOptionProps) {
  const inheritedDisabled = useControlDisabled();
  const { answers, onAnswerChange } = useBespokeSectionContext();
  const isChecked = answers[qid] === value;

  return (
    <div
      data-qid={qid}
      className={className ?? 'flex justify-center items-center'}
    >
      <input
        type='radio'
        className='cursor-pointer accent-blue-600 h-4 w-4'
        disabled={inheritedDisabled}
        checked={isChecked}
        onChange={() => onAnswerChange(qid, value)}
        onClick={() => {
          if (isChecked) onAnswerChange(qid, '');
        }}
      />
    </div>
  );
}
